export default "__VITE_ASSET__BAL3Fe3n__"